import { BorrowerEmployment } from '../../../shared/models/deal-resources/borrower-employment.model';
import { ModelValidator } from '../../../shared/validation/model-validator';

import { ClientJourneyValidationMetadata } from '../../../shared/validation/client-journey-validation-metadata';

export enum BorrowerEmploymentValidationRules {
  CompanyName = 'companyName',
  JobTitle = 'jobTitle',
  IncomeStartDate = 'start',
  IncomeEndDate = 'end',
  IncomeAmount = 'income',
}

export class BorrowerEmploymentValidator extends ModelValidator<
  BorrowerEmployment,
  ClientJourneyValidationMetadata
> {
  constructor(borrowerEmployment: BorrowerEmployment) {
    super(borrowerEmployment);

    let navigationMetadata = <ClientJourneyValidationMetadata>{
      blocksNavigation: false,
      showInMenu: true,
    };

    //Company name
    this.ruleFor(
      employment => employment.companyName,
      BorrowerEmploymentValidationRules.CompanyName,
      navigationMetadata,
    ).must(companyName => companyName?.length > 0);

    //Company name
    this.ruleFor(
      employment => employment.jobTitle,
      BorrowerEmploymentValidationRules.JobTitle,
      navigationMetadata,
    )
      .when(employment => !employment.selfEmployed)
      .must(jobTitle => jobTitle?.length > 0);

    //income
    this.ruleFor(
      employment => employment.income,
      BorrowerEmploymentValidationRules.IncomeAmount,
      navigationMetadata,
    ).must(income => income > 0);

    //start date
    this.ruleFor(
      employment => employment.start,
      BorrowerEmploymentValidationRules.IncomeStartDate,
      navigationMetadata,
    ).must(startDate => startDate != null);

    //end date
    this.ruleFor(
      employment => employment.end,
      BorrowerEmploymentValidationRules.IncomeEndDate,
      navigationMetadata,
    )
      .when(employment => employment.isCurrent == false)
      .must(endDate => endDate != null);

    // // selfEmployedPaymentMethod
    // this.ruleFor(
    //   employment => {
    //     let hasPaymentMethod =
    //       employment.selfEmployedCommissionPaymentMethod ||
    //       employment.selfEmployedBusinessIncomePaymentMethod ||
    //       employment.selfEmployedDividendsPaymentMethod ||
    //       employment.selfEmployedT4PaymentMethod;
    //     return hasPaymentMethod;
    //   },
    //   BorrowerEmploymentValidationRules.SelfEmployedPaymentMethod,
    //   navigationMetadata,
    // )
    //   .when(employment => employment.selfEmployed)
    //   .must(hasPaymentMethod => hasPaymentMethod);
  }

  override validate(key?: string): void {
    super.validate(key);
  }
}
